// @ts-nocheck


import React from 'react';
import styled from 'styled-components';

import {
  Card,
  Filter,
  Selects,
  OrgUnitSelect,
  FilterButtonsContainer } from
'./../../../components';

import { serviceTypeEnum } from '../../../lib/enum';

import FilterContainer from '../../../components/hoc/FilterContainer';
import FilterItem from '../../../components/hoc/FilterItem';
import { InputNumber } from '../../../components/inputs';

const { Field } = Card;
const { MonthlyWashingPlanStatusSelect, ContractorSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-1qgd0e7-0" })(["padding:16px;"]);
















const MonthlyWashingPlanFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      initialValues={filter}
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      additionalFilter={true}>

        {({
        values,
        changeValue,
        cleanFilter,
        showAdditional,
        handleAdditional,
        applyFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect
              size="small"
              value={values.nodeId}
              onChange={(id) => changeValue('nodeId', id)} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <MonthlyWashingPlanStatusSelect
              size="small"
              value={values.status}
              onChange={(id) => changeValue('status', id)} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <ContractorSelect
              size="small"
              value={values.contractorId}
              onChange={(id) => changeValue('contractorId', id)}
              filter={{
                services: [serviceTypeEnum.vehicleWash]
              }} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <InputNumber
              size="small"
              placeholder="Год"
              value={values.year}
              min={2000}
              onChange={(year) => changeValue('year', year)} />

              </Field>
            </FilterItem>
            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter}
          handleAdditional={handleAdditional}
          showAdditional={showAdditional} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;


export default MonthlyWashingPlanFilter;
